import { NotificationTypeEnum } from '@/enums/NotificationTypeEnum'
import { EventsTypes } from '@/enums/EventsTypes'

export const getNotificationIcon = (type: string, eventType?: string) => {
  switch (type) {
    case NotificationTypeEnum.ServiceRequestCreated:
    case NotificationTypeEnum.ServiceRequestCompleted:
      return 'mdi-face-agent';

    case NotificationTypeEnum.ScheduledCall:
      return 'mdi-phone-clock';

    case NotificationTypeEnum.RealtimeCall:
      return 'mdi-phone';

    case NotificationTypeEnum.UnattendedEventEnded:
      if (eventType === EventsTypes.ScheduledCall ||eventType === EventsTypes.RealtimeCall) {
        return 'mdi-phone-alert';
      }
      return 'mdi-calendar-alert';

    case NotificationTypeEnum.MaintenanceRequestCreated:
      return 'mdi-wrench';

    case NotificationTypeEnum.MaintenanceRequestCompletionDeadline:
      return 'mdi-wrench';

    case NotificationTypeEnum.VisitCreated:
      return 'mdi-book-open-variant';

    case NotificationTypeEnum.DeviceAssigned:
      return 'mdi-cellphone';

    case NotificationTypeEnum.DeviceUnassigned:
      return 'mdi-cellphone-remove';

    case NotificationTypeEnum.BookingsAndOrdersComment:
      return 'mdi-comment-text-multiple-outline';

    case NotificationTypeEnum.StaffAppResidentUpcomingCall:
      return 'mdi-video-account';

    case NotificationTypeEnum.StaffAppResidentSuggestedUserStory:
      return 'mdi-clipboard-text-clock-outline';

    case NotificationTypeEnum.Message:
    case NotificationTypeEnum.HomeMessage:
      return 'mdi-message';

    case NotificationTypeEnum.TransferResident:
      return 'mdi-swap-horizontal';
      
    case NotificationTypeEnum.VideoCallInvite:
      return 'mdi-phone-plus';

    case NotificationTypeEnum.VideoCallCancelled:
      return 'mdi-phone-cancel'; 
    
    case NotificationTypeEnum.ReScheduledCall :
      return 'mdi-calendar-clock';

    case NotificationTypeEnum.FeedbackRequestStale :
      return 'mdi-file-alert';

    default:
      return 'mdi-bell-outline';
  }
}
